import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CurrencyFormat from 'react-currency-format';
import { useTranslation } from "react-i18next";

//import api
import { transferCurrency } from "../../api/walletAction";

//import lib
import isEmpty from "../../lib/isEmpty";
import { toFixedDown, truncateDecimals } from "../../lib/roundOf"
import { toastAlert } from "../../lib/toastAlert";

//import validation
import { Validation } from "./validation"

const initialFormValue = {
    fromCurrencyId: "",
    toCurrencyId: "",
    amount: 0
}

const ExchangeModal = (props) => {

    //props
    const { isShow, record, onHide } = props

    //redux
    const currency = useSelector((state) => state.currency);
    const walletData = useSelector((state) => state.wallet);
    const priceConversion = useSelector((state) => state.priceConversion);

    //hooks
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()

    //state
    const [options, setOption] = useState([])
    const [loader, setLoader] = useState(false)
    const [errors, setErrors] = useState({})
    const [formValue, setFormValue] = useState(initialFormValue)
    const { fromCurrencyId, toCurrencyId, amount } = formValue;
    const [convertAmount, setConAmount] = useState(0)
    const [toCurrency, settoCurrency] = useState("")




    //function
    const handleClick = () => {
        let formData = { ...formValue, ...{ ["amount"]: toFixedDown(record?.stakeBal - record?.lockedBal, 8) } };
        setFormValue(formData);
    }

    const hanldeClose = () => {
        onHide()
        setErrors({})
        setFormValue(initialFormValue)
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        let formData = { ...formValue, ...{ [name]: (value) } }
        setFormValue(formData);
        if (!isEmpty(errors)) {
            setErrors({});
        }
    }

    const handleAmount = (e) => {
        const { name, value } = e.target;
        if (/[^0-9.]/.test(value)) return;
        let formData = { ...formValue, ...{ [name]: toFixedDown(value, 8) } }
        setFormValue(formData);
        if (!isEmpty(errors)) {
            setErrors({});
        }
    }

    const fetchData = () => {
        let array = []
        walletData && walletData.length > 0 && walletData.map((item, key) => {
            let findata = currency && currency.find((el) => el._id == item._id);
            // console.log(findata, 'item')
            array.push({
                value: findata?._id,
                label: findata?.currencySymbol,
                image: findata?.image,
            })
        })
        setOption(array)
    }


    const handleAsset = () => {
        let fromCurrency = record?.coin == 'USDT' ? "USD" : record?.coin
        let toCurrency = currency && currency.find((el) => el._id.toString() == toCurrencyId.toString());
        let convertSymbol = toCurrency?.currencySymbol == 'USDT' ? "USD" : toCurrency?.currencySymbol
        settoCurrency(toCurrency?.currencySymbol)
        let priceCNV;
        if (priceConversion && priceConversion.length > 0) {
            priceCNV = priceConversion.find((el) => el.baseSymbol == fromCurrency && el.convertSymbol == convertSymbol || el.baseSymbol == convertSymbol && el.convertSymbol == fromCurrency);
        }
        // console.log(priceCNV, 'price/CNV')
        // console.log(convertSymbol, 'convertSymbol', record?.coin)
        let conPrice = convertSymbol != priceCNV?.convertSymbol ? (1 / priceCNV?.convertPrice) : priceCNV?.convertPrice
        // console.log(conPrice, 'conPrice')
        setConAmount(conPrice * amount)
    }


    const handleSubmit = async () => {
        try {
            setLoader(true)
            let reqData = {
                fromCurrencyId: record?._id,
                toCurrencyId: toCurrencyId,
                amount: amount
            }
            let validationError = Validation(reqData);
            if (!isEmpty(validationError)) {
                setErrors(validationError);
                setLoader(false);
                return;
            }
            const { status, error, loading, message } = await transferCurrency(reqData, dispatch)
            setLoader(loading)
            if (status == 'success') {
                setLoader(false)
                hanldeClose()
                toastAlert("success", t(message), "login");
            } else {
                setLoader(false)
                if (error) {
                    setErrors(error)
                }
                toastAlert("error", t(message), "login");
            }
        } catch (err) {
            setLoader(false)
            console.log(err, 'error')
        }
    }


    useEffect(() => {
        if (isShow) {
            fetchData()
        }
    }, [walletData, isShow, currency, priceConversion])

    useEffect(() => {
        handleAsset()
    }, [amount, toCurrencyId, record])


    // console.log(record, 'record')
    let Balance = record?.stakeBal - record?.lockedBal

    return (
        <>
            <Modal show={isShow}
                onHide={hanldeClose}
                backdrop="static"
                keyboard={false}
                size="md"
                centered >
                <Modal.Header className="justify-between" >
                  <Modal.Title><h4 className="modal-title mt-0 model_head">
                        {t("EXCHANGE")} </h4> </Modal.Title>
                        <button type="button" className="border-0 bg-transparent p-0" aria-label="Close" onClick={hanldeClose}>
                        <svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 0.9375C13.4528 0.9375 17.0625 4.54721 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.54721 17.0625 0.9375 13.4528 0.9375 9C0.9375 4.54721 4.54721 0.9375 9 0.9375ZM7.22315 6.16846C6.92858 5.9282 6.49432 5.94517 6.21973 6.21973C5.94523 6.49432 5.92822 6.9286 6.16846 7.22315L6.21973 7.28027L7.93943 9L6.22046 10.7198C5.92768 11.0126 5.92758 11.4874 6.22046 11.7802C6.51335 12.0729 6.98818 12.073 7.28101 11.7802L9 10.0606L10.719 11.7802L10.7762 11.8316C11.0706 12.0718 11.5049 12.0547 11.7796 11.7802C12.0541 11.5058 12.0716 11.0714 11.8316 10.7768L11.7796 10.7198L10.0598 9L11.7802 7.28027L11.8316 7.22315C12.0718 6.92859 12.0547 6.49432 11.7802 6.21973C11.5057 5.94517 11.0714 5.9282 10.7768 6.16846L10.7198 6.21973L9 7.93943L7.28027 6.21973L7.22315 6.16846Z" fill="#395645" />
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <form className="assets_form">
                        <div className="mb-3">
                            <div className="d-flex align-items-center justify-content-between">
                                <label for="withdrawamount" className="form-label">
                                    {t("FROM_CURRENCY")}
                                </label>
                                <label class="form-label">{t("AVAILABLE_BALANCE")}:  <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(Balance, record?.decimals)} /> {record?.coin}</label>
                            </div>
                            <input
                                type="text"
                                class="form-control primary_asset_inp"
                                placeholder="0.000000"
                                name="fromCurrencyId"
                                value={record?.coin}
                                disabled
                            />
                        </div>
                        <div className="mb-3">
                            <div className="d-flex align-items-center justify-content-between">
                                <label for="withdrawamount" className="form-label">
                                    {t("TO_CURRENCY")}
                                </label>
                            </div>
                            <select
                                value={toCurrencyId}
                                name="toCurrencyId"
                                onChange={handleChange}
                                className="form-select primary_asset_select">
                                <option value={""} >{t("SELECT_CURRENCY")}</option>
                                {
                                    options && options.length > 0 && options.map((item, key) => {
                                        if (record?.coin != item.label) {
                                            return (
                                                <option value={item.value} key={key}>
                                                    {item.label}
                                                </option>
                                            )
                                        }
                                    })
                                }
                            </select>
                            <span className='text-danger'>{t(errors?.toCurrencyId)}</span>
                        </div>
                        <div className="mb-3">
                            <div className="d-flex align-items-center justify-content-between">
                                <label for="withdrawamount" className="form-label">
                                    {t("AMOUNT")}
                                </label>
                                <label className="max_label"
                                    onClick={handleClick}
                                >{t("MAX")}</label>
                            </div>
                            <div class="input-group">
                                <input
                                    type="number"
                                    class="form-control primary_asset_inp"
                                    placeholder="0.000000"
                                    name="amount"
                                    value={amount}
                                    onChange={handleAmount}
                                />
                                <span
                                    class="primary_asset_inp"
                                >{record?.coin}</span>
                            </div>
                            <div class="form-text ms-3">≈ {toCurrency ? toCurrency : ""}   <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(convertAmount ? convertAmount : 0, 4)} /></div>
                            <span className='text-danger'>{t(errors?.amount)}</span>
                        </div>
                        <div className="w-full inline-flex justify-start items-center gap-2 mt-4">
                            <button type="button"
                                className="flex-1 h-10 px-4 relative bg-gray-300 hover:bg-gray-400 active:bg-gray-500 active:scale-95 transition-all duration-200 rounded-sm flex justify-center items-center overflow-hidden border-0"
                                onClick={hanldeClose}
                            >
                                <div className="text-center justify-center text-[#395645] text-base font-medium font-['Roobert']">{t("CANCEL")}</div>
                            </button>
                            {
                                loader ?
                                    <button type="button" className="flex-1 h-10 px-4 relative bg-[#395645] rounded-sm flex justify-center items-center overflow-hidden border-0 opacity-70 cursor-not-allowed" disabled={true}>
                                        <div className="text-center justify-center text-zinc-100 text-base font-medium font-['Roobert']">{t("LOADING")}...</div>
                                    </button> :
                                    <button type="button" onClick={handleSubmit} className="flex-1 h-10 px-4 relative bg-[#395645] hover:bg-[#2a4033] active:bg-[#1d2d24] active:scale-95 transition-all duration-200 rounded-sm flex justify-center items-center overflow-hidden border-0">
                                        <div className="text-center justify-center text-zinc-100 text-base font-medium font-['Roobert']">{t("CONFIRM")}</div>
                                    </button>
                            }
                        </div>
                        
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}


export default ExchangeModal;